import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "checkbox",
    "priceInput",
    "destroyInput",
    "priceDisplay",
    "lengthInput",
  ];
  static values = { price: Number };

  connect() {
    this.updatePrice();

    if (this.hasLengthInputTarget) {
      this.lengthInputTarget.addEventListener("input", () =>
        this.updatePrice()
      );
    } else {
      this.findAndListenToLengthInput();
    }
  }

  disconnect() {
    if (this.lengthInputElement) {
      this.lengthInputElement.removeEventListener(
        "input",
        this.boundUpdatePrice
      );
    }
  }

  toggle() {
    this.updatePrice();
  }

  updatePrice() {
    const enabled = this.checkboxTarget.checked;
    const length = this.getLength();
    const totalPrice =
      length === 0 ? this.priceValue : length * this.priceValue;

    this.priceInputTarget.value = totalPrice;
    this.destroyInputTarget.value = enabled ? "0" : "1";

    this.priceDisplayTarget.textContent = this.formatCurrency(totalPrice);
  }

  getLength() {
    if (this.hasLengthInputTarget) {
      return parseFloat(this.lengthInputTarget.value) || 0;
    }

    const lengthInput = document.querySelector('[name*="[length]"]');
    return parseFloat(lengthInput?.value) || 0;
  }

  findAndListenToLengthInput() {
    this.lengthInputElement = document.querySelector('[name*="[length]"]');
    if (this.lengthInputElement) {
      this.boundUpdatePrice = this.updatePrice.bind(this);
      this.lengthInputElement.addEventListener("input", this.boundUpdatePrice);
    }
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  }
}
